<script>
import FooterWrapper from "@/components/FooterWrapper";
export default {
  // Included components
  components: {
    FooterWrapper,
  },
};
</script>

<template>
  <FooterWrapper>
    <b-container fluid class="mt-3">
      <b-row align-h="center">
        <b-col lg="9" xl="8">
          <b-row class="mb-3">
            <b-col>
              <h1>Password Reset</h1>
            </b-col>
          </b-row>

          <b-card class="text-center py-5">
            <b-card-title>Check Your Email</b-card-title>
            <b-card-text>
              You should see an email with a link to reset your password
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </FooterWrapper>
</template>
